import DisplayImageDialog from "./displayImageDialog.container";
export default DisplayImageDialog;
